(() => {
  const nav = document.querySelector('[data-nc-choices]');
  if (!nav) return;
  const scope = document.body.dataset.novoCollection;
  const status = document.querySelector('[data-nc-status]');
  let active = 'all';
  const category = (handle) => {
    if (scope === 'all-lash-extensions-for-proff') {
      if (handle.includes('premade') || handle.includes('pre-made')) return 'premade';
      if (handle.includes('flat')) return 'flat';
      if (handle.startsWith('volume-')) return 'volume';
      if (handle.startsWith('one-by-one-') || handle.startsWith('classic-')) return 'classic';
      return 'other';
    }
    if (scope === 'diy-cluster') {
      if (['amara-fast-lashes','anaya-fast-lashes'].includes(handle)) return 'by_length';
      if (['nola-diy-cluster','viola-diy-cluster-starterkit-copy','dune-diy-cluster','viola-diy-cluster-copy'].includes(handle)) return 'clusters';
      if (handle.includes('starterkit') || handle === 'nola-diy-cluster-copy') return 'sets';
      return 'essentials';
    }
    if (['advanced-glue-black','expert-glue-black'].includes(handle)) return 'glue';
    if (handle.includes('remover')) return 'removers';
    if (handle.startsWith('vetus-') || ['diy-cluster-tweezer','novo-tweezer'].includes(handle)) return 'tweezers';
    if (handle.includes('tape') || ['eye-pads','glue-wipes'].includes(handle)) return 'tape';
    return 'care';
  };
  const apply = () => {
    const grid = document.getElementById('product-grid');
    if (!grid) {status.hidden = true;return;}
    let count = 0;
    grid.querySelectorAll('[data-nc-handle]').forEach(card => {
      const visible = active === 'all' || category(card.dataset.ncHandle) === active;
      card.hidden = !visible;
      if (visible) count++;
    });
    const next = count === 0 && status.dataset.empty ? status.dataset.empty : status.dataset.pattern.replace('__COUNT__', count);
    if (status.textContent !== next) status.textContent = next;
    status.hidden = active === 'all';
    if (scope === 'all-lash-extensions-for-proff' && status.dataset.countPattern) {
      document.querySelectorAll('.collection-count > span, .load-more-amount').forEach(label => {
        const text = status.dataset.countPattern.replace('__COUNT__', count);
        if (label.textContent !== text) label.textContent = text;
      });
    }
  };
  nav.hidden = false;
  nav.addEventListener('click', event => {
    const button = event.target.closest('[data-nc-filter]');
    if (!button) return;
    active = button.dataset.ncFilter;
    nav.querySelectorAll('button').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
    apply();
  });
  let queued = false;
  const observer = new MutationObserver(() => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => {queued = false;apply();});
  });
  const main = document.getElementById('MainContent') || document.querySelector('main');
  if (main) observer.observe(main, {childList:true, subtree:true});
  apply();
})();
